import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { IAlertHandlerState } from './interfaces';

const initialState: IAlertHandlerState = {
  open: false,
  title: '',
  content: '',
  primaryButton: 'OK',
  secondaryButton: 'Cancelar',
};

const alertHandlerSlice = createSlice({
  name: 'alertHandler',
  initialState,
  reducers: {
    openAlert(state, action: PayloadAction<IAlertHandlerState, string>) {
      state.open = true;
      state.title = action.payload.title;
      state.content = action.payload.content || '';
      state.primaryButton =
        action.payload.primaryButton || initialState.primaryButton;
      state.secondaryButton = action.payload.secondaryButton;
      state.primaryButtonAction = action.payload.primaryButtonAction;
      state.secondaryButtonAction = action.payload.secondaryButtonAction;
      return state;
    },
    closeAlert() {
      return initialState;
    },
  },
});

const { reducer, actions } = alertHandlerSlice;
export const { openAlert, closeAlert } = actions;
export default reducer;
